<template>
<div>
    <div v-if="loading">
        <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Detail_Placeholder_Desktop_v1.svg" alt="">
        <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Detail_Placeholder_Tablet_v1.svg" alt="">
        <img class="hidden-md hidden-lg" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Detail_Placeholder_Mobile_v1.svg" alt="">
    </div>
    <div v-if="!loading">
        <div class="session-detail-wrapper">
            <div v-if="session && session._id" class="session-tile mt-3 mb-2">
            </div>
            <div class="d-flex flex-wrap" v-if="session && session._id">
                <div class="col-12 col-lg-4 col-xl-3 pl-0" v-if="session && session.experts && session.experts.length">

                    <div class="speaker-boxes ws-lp rounded-l mb-4">
                        <h3>Speaker</h3>
                        <div v-for="expert in session.experts" :key="expert.id">
                            <div class="gdlr-speaker-thumbnail mt-2">
                                <div class="gdlr-speaker-thumbnail-inner" v-if="expert && expert.surname && expert.forename && expert.slug">
                                    <router-link :to="`/speaker/${expert.slug}`">
                                        <div v-if="expert && expert.avatarSquareSmall && expert.avatarSquareSmall.xxx" class="sands-image-colored-overlay-hover">
                                            <img :src="expert.avatarSquareSmall.xxx" alt="Manfred Steyer" width="500" height="350"></div>
                                        <div class="span-speaker-container">
                                            <p class="span-speaker-left"><span>{{expert.forename}}</span> <span> {{expert.surname}}</span></p>
                                            <p class="span-speaker-right">More Info</p>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="gdlr-speaker-thumbnail-inner" v-if="expert && expert.surname && expert.forename && !expert.slug">
                                    <div v-if="expert && expert.avatarSquareSmall && expert.avatarSquareSmall.xxx" class="sands-image-colored-overlay-hover">
                                        <img :src="expert.avatarSquareSmall.xxx" alt="Manfred Steyer" width="500" height="350"></div>
                                    <div class="span-speaker-container">
                                        <p class="span-speaker-left"><span>{{expert.forename}}</span> <span> {{expert.surname}}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="widgetHtml" class="call-for-action-box old-layout">
                        <span v-html="widgetHtml"></span>
                    </div>
                </div>
                <!-- expert section ends -->
                <div class="col-12 col-lg-8 col-xl-9">
                    <!-- info start -->
                    <div class="top-info-container rounded-l mb-3" v-if="session.workshopShortLabel || session.roomName || (session.localizedStartDate && showTimeAndDate)">
                        <h5 class="infoBlock">Infos</h5>
                        <div class="top-info-flex  d-flex flex-wrap justify-content-center">
                            <div class="top-info" v-if="session && session.localizedStartDate && session.localizedEndDate && showTimeAndDate">
                                <span class="ws-label h5" style="font-weight: 600;">{{formatDate(session.localizedStartDate,true)}}<br><span style="font-weight: 400;">{{formatDate(session.localizedStartDate,false)}} - {{formatDate(session.localizedEndDate,false)}}</span></span>
                            </div>
                            <div v-if="session && session.roomName">
                                <div class="top-info">
                                    <span class="ws-label">Room: <br>
                                        {{session.roomName}}
                                    </span>
                                </div>
                            </div>
                            <div v-if="session && session.workshopShortLabel">
                                <div class="top-info top-info-last">
                                    <strong>Booking note: <br></strong>
                                    {{session.workshopShortLabel}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- info ends -->
                    <div id="accordion">
                        <!-- description start -->
                        <div class="card border-0 rounded-l">
                            <div class="top-info-container" id="headingOne" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <h5 class="mb-0 cursorPointer">
                                    Description
                                </h5>
                            </div>

                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                <div class="card-block session-desc-content px-3 py-2">
                                    <template v-if="session && session.details">
                                        <div v-html="session.details">
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <!-- description ends-->

                        <!-- Long Abstract start -->
                        <div v-if="session && session.longAbstract" class="mt-4">
                            <div class="card border-0 rounded-l">
                                <div class="top-info-container" id="headingTwo" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <h5 class="mb-0 cursorPointer">
                                        Content-Process
                                    </h5>
                                </div>
                                <div id="collapseFour" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                    <div class="card-block session-desc-content px-3 py-2">
                                        <template v-if="session && session.longAbstract">
                                            <div v-html="session.longAbstract">
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- longabstract ends -->
                        <!-- more workshopRequirements start -->
                        <div v-if="session && session.workshopRequirements" class="mt-4">
                            <div class="card border-0 rounded-l">
                                <div class="top-info-container" id="headingFive" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <h5 class="mb-0 cursorPointer">
                                        Audience & Requirements
                                    </h5>
                                </div>
                                <div id="collapseFive" class="collapse in" aria-labelledby="headingFive" data-parent="#accordion">
                                    <div class="card-block session-desc-content px-3 py-2">
                                        <template v-if="session && session.workshopRequirements">
                                            <div v-html="session.workshopRequirements">
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- more workshopRequirements ends -->
                        <!-- more sessions start -->
                        <div v-if="relatedTracks && relatedTracks.length" class="my-4">
                            <div class="card border-0 rounded-l">
                                <div class="top-info-container">
                                    <h5 class="mb-0">
                                        More Sessions on the Tracks
                                    </h5>
                                </div>
                                <div>
                                    <div class="card-block session-desc-content px-3 py-2">
                                        <div v-for="(atrack, index) in relatedTracks" :key="index">
                                            <h5 v-if="atrack && atrack.name" class="old-accordion-title old-ijsstyle old-classicstyle"><span>{{atrack.name}}</span></h5>
                                            <div class="d-flex flex-wrap" v-if="atrack && atrack.trackSessions && atrack.trackSessions.vueSessions && atrack.trackSessions.vueSessions.Sessions && atrack.trackSessions.vueSessions.Sessions.length">
                                                <template v-for="arelatedTrack in atrack.trackSessions.vueSessions.Sessions" :key="arelatedTrack._id">
                                                    <li class="trackName w-100 py-1" 
                                                    v-if="arelatedTrack && arelatedTrack.name && arelatedTrack.slugNames && arelatedTrack.slugNames[0] 
                                                    && arelatedTrack.primaryTrack && arelatedTrack.primaryTrack.slug && arelatedTrack._id && session._id && arelatedTrack._id != session._id">
                                                        <router-link v-if="arelatedTrack.slugNames && arelatedTrack.slugNames[0] && arelatedTrack.primaryTrack && arelatedTrack.primaryTrack.slug" :to="`/session/${arelatedTrack.slugNames[0]}`">{{arelatedTrack.name}}</router-link>
                                                    </li>
                                                </template>

                                                <!-- <li class="w-100 py-1"><a v-if="atrack && atrack.slug" :href="'/'+atrack.slug">read more</a></li> -->
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- more sessions ends -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'
import {
    useRoute
} from 'vue-router'
import moment from 'moment';
export default {
    name: 'sessionDetail',
    props: {
        settingsPerm: Object
    },
    data() {
        return {
            session: false,
            relatedTracks: [],
            widgetHtml: false,
            loading: true,
            showTimeAndDate: false,
            manipulateSessionTimeBy: false,
        };
    },
    setup() {
        const route = useRoute();
        return route;
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    beforeRouteUpdate(to, from, next) {
        this.loading = true;
        // Call the API query method when the URL changes
        this.fetchData(to.params.slug);
        next()
    },
    created() {
        if (this.settingsPerm && this.settingsPerm.callToAction) {
            this.widgetHtml = this.settingsPerm.callToAction;
        }
        if (this.settingsPerm && this.settingsPerm.manipulateSessionTimeBy) {
            this.manipulateSessionTimeBy = this.settingsPerm.manipulateSessionTimeBy;
        }
        if (this.settingsPerm && this.settingsPerm.showTimeAndDates) {
            this.showTimeAndDate = this.settingsPerm.showTimeAndDates;
        }
        this.fetchData(this.$route.params.slug);
    },
    methods: {
        fetchData: function (slug) {
            this.relatedTracks = [];
            if (this.settingsPerm && this.settingsPerm.brandId && this.settingsPerm.concordBackendURL) {
                const cache = new InMemoryCache();
                const apolloClient = new ApolloClient({
                    cache,
                    uri: this.settingsPerm.concordBackendURL,
                })
                provideApolloClient(apolloClient)
                let variablesForQier = {
                    sessionSlug: slug,
                    brandId: this.settingsPerm.brandId
                };
                const {
                    result
                } = useQuery(CONCORD_QUERIES.SESSION_BY_SLUG_QUERY, variablesForQier, {
                    fetchPolicy: 'cache-first',
                });
                watch(result, value => {
                    if (value && value.vueSessions && value.vueSessions.Sessions && value.vueSessions.Sessions.length) {
                        this.session = value.vueSessions.Sessions[0];
                        this.emitter.emit('infoFromChild', {
                            'isSessionDetail': true,
                            'sessionName': this.session.name
                        });
                        if (this.session && this.session.tracks && this.session.tracks.length) {
                            this.session.tracks.forEach(aTrack => {
                                let duplicate = aTrack;
                                duplicate = Object.assign({
                                    trackSessions: []
                                }, aTrack);
                                let isTrackAlredyInRelatedTracks = this.relatedTracks.find(track => track._id === aTrack._id);
                                if (!isTrackAlredyInRelatedTracks) {
                                    this.relatedTracks.push(duplicate);
                                    this.getSesisonsByTrack(aTrack, this.session.conferenceIds[0])
                                }
                            });
                            this.emitter.emit('tracksRelatedSessions', this.relatedTracks);
                        }
                        //meta Data for session Start
                        let meta = {
                            "title": this.session.name,
                            "description": this.session.details,
                            "robots": "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
                            "canonical": window.location.href,
                            "og:locale": "en_GB",
                            "og:type": "article",
                            "og:title": this.session.name,
                            "og:description": this.session.details,
                            "og:url": window.location.href,
                            "og:site_name": "DEVM.IO",

                        }
                        if (document.querySelector("[name='title']")) {
                            document.querySelector("[name='title']").remove();
                        }
                        if (document.querySelector("[name='description']")) {
                            document.querySelector("[name='description']").remove();
                        }
                        if (document.querySelector("[name='robots']")) {
                            document.querySelector("[name='robots']").remove();
                        }
                        if (document.querySelector("[name='og:type']")) {
                            document.querySelector("[name='og:type']").remove();
                        }
                        if (document.querySelector("[name='og:title']")) {
                            document.querySelector("[name='og:title']").remove();
                        }
                        if (document.querySelector("[name='og:description']")) {
                            document.querySelector("[name='og:description']").remove();
                        }
                        if (document.querySelector("[name='og:url']")) {
                            document.querySelector("[name='og:url']").remove();
                        }

                        let metaArry = Object.keys(meta);
                        metaArry.forEach(key => {
                            var metaTag = document.createElement('meta');
                            metaTag.setAttribute('name', key);
                            metaTag.setAttribute('content', meta[key]);
                            document.getElementsByTagName('head')[0].appendChild(metaTag)
                        });
                        //meta data for session detail ends
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                })
            }
        },
        formatDate(localizedDate, state) {
            if (localizedDate && state) {
                if (this.manipulateSessionTimeBy) {
                    if (Math.sign(this.manipulateSessionTimeBy) === 1) {
                        return localizedDate = moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(this.manipulateSessionTimeBy), 'hours').format('dddd, DD. MMMM YYYY');
                    } else if (Math.sign(this.manipulateSessionTimeBy) === -1) {
                        return localizedDate = moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(this.manipulateSessionTimeBy), 'hours').format('dddd, DD. MMMM YYYY');
                    }
                } else {
                    return localizedDate = moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').format('dddd, DD. MMMM YYYY');
                }

            } else if (localizedDate) {



                if (this.manipulateSessionTimeBy) {
                    if (Math.sign(this.manipulateSessionTimeBy) === 1) {
                        return localizedDate = moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(this.manipulateSessionTimeBy), 'hours').format('HH:mm');
                    } else if (Math.sign(this.manipulateSessionTimeBy) === -1) {
                        return localizedDate = moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(this.manipulateSessionTimeBy), 'hours').format('HH:mm');
                    }
                } else {
                    return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
                }
            }
            return localizedDate;
        },
        getSesisonsByTrack(aTrack, conferenceId) {
            let variablesForQier = {
                id:aTrack._id,
                conferenceId:conferenceId
            };
            const {
                result
            } = useQuery(CONCORD_QUERIES.SESSION_BY_TRACK_QUERY, variablesForQier, {
                fetchPolicy: 'cache-first',
            });
            watch(result, value => {
                if (result && value) {

                    this.relatedTracks.forEach(track => {
                        if (track._id === aTrack._id) {
                            track.trackSessions = value;
                        }
                    });
                }
            });
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

.speaker-boxes {
    box-shadow: 5px 5px 20px rgb(0 0 0 / 10%) !important;
    background-color: #fff;
    box-shadow: 0 -1px 0 #e5e5e5, 0 0 2px rgb(0 0 0 / 12%), 0 2px 4px rgb(0 0 0 / 24%);
    padding: 0 0 9px 0;
    margin: 0 0 20px 0;
}

.gdlr-speaker-thumbnail {
    margin: 0 20px 30px 20px;
}

.speaker-boxes h3 {
    padding: 15px 20px 10px 20px;
    border-bottom: 1px solid #efefef;
    margin-top: 0;
}

.rounded-l {
    box-shadow: 5px 5px 20px rgb(0 0 0 / 10%) !important;
    border-radius: 5px !important;
}

.top-info-container h5 {
    margin: 0;
    font-size: 20px;
    padding: 10px 20px 10px 17px;
    border-bottom: 1px solid #efefef;
}

.top-info-flex .top-info {
    height: unset !important;
}

.top-info-flex .top-info {
    border-right: 1px solid #efefef;
    height: 100%;
    padding: 30px;
    margin: 0;
    flex: 1;
    text-align: center;
}
.top-info-last{
    border:none !important;
}

.span-speaker-left {
    color: #000;
    text-decoration: none;
    font-size: 18px;
    margin: 0;
}

.span-speaker-right {
    color: #c1c1c1;
}

.session-top-track {
    background-color: #ec5f72;
    color: white;
    border-radius: 20px;
}

.span-speaker-right:after {
    content: "\f105";
    font-family: FontAwesome;
    font-weight: 400;
    font-style: normal;
    margin: 0 0 0 10px;
    text-decoration: none;
    color: #c1c1c1;
    position: relative;
}
</style>
